import React from 'react';
import './CardInfo.css';

type CardInfoProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  title: string,
  dcp: string,
  img?: string
}

const CardInfo: React.FC<CardInfoProps> = ({ title, dcp, img, ...props }) => {
  // const showLines

  return (
    <div {...props} className={`mt-10 p-3 sm:p-3 md:p-3 lg:p-6 xl:p-8 ${props.className ? props.className : ''}`} style={{width: "100%"}}>
      <div className="flex justify-center showShadow">
        <img src={img} alt=''/>
      </div>
      <div className="text-2xl font-bold pt-5 text-center">{title}</div>
      <div className="text-left text-gray-600 pt-3">{dcp}</div>
    </div>
  )   
}

export default CardInfo;